import RouteContainer from 'containers/RouteContainer';
import Component from './containers/StatusContainer';

export const path = `${DOCUMENTS_PATH}/status`;
export const navigation = { name: 'status', id: 'status.title' };
export const navPREDSS = { name: 'predss', id: 'predss.title', nonNavigable: true };

export default RouteContainer(path, Component);
